import { Alert, Col, ControlLabel, Row } from 'react-bootstrap';
import displayCurrency from '../../../../../../helpers/displayCurrency';
import { get } from 'lodash';
import { Field } from 'redux-form';
import {
  CheckboxGroup,
  TextField,
} from '../../../../../../common/components/ReduxFormField';
import { Icon, PaymentOptions } from '../../../../../../common/components';
import getPaymentOptions from '../../../../../../helpers/getPaymentOptions';
import getOwnerBrokerType from '../../../../../../helpers/getOwnerBrokerType';
import React, { useState } from 'react';
import { ReferenceField } from '../ReferenceField/ReferenceField';
import { required } from 'redux-form-validators';
import PaymentIFrame from '../../../../../../common/components/PaymentIFrame/PaymentIFrame';
import './PaymentDetails.scss';

const Error = ({ message }) => {
  if (!message) {
    return null;
  }
  return <Alert bsStyle={'danger'}>PaymentError: {message}</Alert>;
};
export const PaymentDetails = ({
  isValid,
  calculatedPremium,
  selectedPremium,
  haveBoltonsChanged,
  isGoldUpgraded,
  isRefund,
  brokerType,
  salesChannel,
  paymentType,
  isPremiumUpdating,
  onToggleRefund,
  onRedirectToIssued,
}) => {
  const [cardError, setCardError] = useState();
  if (!isValid) {
    return null;
  }

  const nonGoldPremium = haveBoltonsChanged
    ? calculatedPremium
    : selectedPremium?.attributes;

  const premium = isGoldUpgraded
    ? selectedPremium?.attributes.premium
    : nonGoldPremium?.premium;

  const rates = isGoldUpgraded
    ? selectedPremium?.attributes.rates
    : nonGoldPremium?.rates;

  if (!premium && !isPremiumUpdating) {
    return <div />;
  }

  return (
    <div className="payment-container">
      <Row>
        <Col sm={12}>
          <div className="hr" style={{ marginBottom: '10px', marginTop: '10px' }} />
          <div className="issue-policy-title padding-title">Payment Details</div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div className="payment-method">Please select a payment method:</div>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div className="total-to-pay-title">
            Total to pay:{' '}
            <span className="total-to-pay-value">
              {!isPremiumUpdating ? (
                <span>
                  {displayCurrency(get(premium, 'gross', 0))}&nbsp; Inc.{' '}
                  {get(rates, 'tax_rate')}%
                </span>
              ) : (
                <span>
                  {' '}
                  <Icon spin name="spinner" />
                </span>
              )}
            </span>
            {haveBoltonsChanged && (
              <div className="total-to-pay-value">
                <small>
                  Note: the new total premium may not reflect the individual add on prices
                  (Travel Dispute and End Supplier failure) if there has been new scheme
                  version, since this quote was created.
                </small>
              </div>
            )}
          </div>
        </Col>
      </Row>

      {premium && premium.gross < 0 && (
        <div>
          <Row>
            <Col sm={12}>
              <div className="confirm-declaration">
                <Field
                  name={'meta.refund'}
                  inline
                  options={[{ label: 'Refund', value: true }]}
                  onChange={onToggleRefund}
                  component={CheckboxGroup}
                />
              </div>
            </Col>
          </Row>
          {!isRefund && (
            <div className="declaration">
              <Row>
                <Col sm={6}>
                  <ControlLabel className="">Reason (lost card etc.) </ControlLabel>
                </Col>
              </Row>
              <Row>
                <Col sm={7}>
                  <Field name="meta.note.content" type="textarea" component={TextField} />
                </Col>
              </Row>
            </div>
          )}
        </div>
      )}
      {premium && premium.gross > 0.0 && (
        <div className="payment-type-container">
          <PaymentOptions
            selectedButtonType={paymentType}
            paymentOptions={getPaymentOptions(
              getOwnerBrokerType(salesChannel, brokerType),
            )}
            validate={required({ msg: 'Payment type is required' })}
          />

          <Error message={cardError} />
          <PaymentIFrame onSuccess={onRedirectToIssued} onFail={setCardError} />

          <ReferenceField paymentType={paymentType} />
        </div>
      )}
    </div>
  );
};
